<!--
    项目团队
-->
<template>
    <div class="project-team-page">
        <div class="personnel-info">人员信息</div>
        <div class="person-box">
            <div v-for="(item,index) in dataList">
                <div class="businessCard"
                     :style="{borderRadius: item.certification.length > 0 ? '24px 24px 0 0' : '24px'}">
                    <div class="person-image"><img :src="item.icon"/></div>
                    <div class="person-info">
                        <div class="position-workCard">
                            <div class="position">{{ item.rel_group_name }}</div>
                            <div class="workCard" v-if="item.job_number.length != ''">工牌：{{ item.job_number }}</div>
                        </div>
                        <div class="center-box">
                            <div>
                                <div class="name">{{ item.name }}</div>
                            </div>
                            <div class="phone-icon" @click="changeIsPopup(item)" v-if="item.qr_code != ''">
                                <img :src="require('@/assets/images/project/ewm-icon.png')"/>
                            </div>
                        </div>
                        <div class="duty">岗位职责：{{ item.desc }}</div>
                    </div>
                </div>
                <div class="qualif-box" v-if="item.certification.length > 0">
                    <div v-for="(item,index) in item.certification" class="tick-box">
                        <div class="tick-icon"><img :src="require('@/assets/images/project/Tick-icon.png')"/></div>
                        <div class="tick-name">{{ item.name }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="home_icon" @click="getHome" :style="{bottom: isShowShare ? '108px':'88px'}">
            <img src="~@/assets/images/processv2/tohome.png"/>
        </div>
        <share ref="myShare" v-if="isShowShare"  :isFixed="true"></share>
        <qrcodePopup :nTitle="arrMent.name" :nEwmImg="arrMent.qr_code" :nPopup.sync="isPopup"></qrcodePopup>
    </div>
</template>

<script>

import qrcodePopup from '../components/qrcode.vue';
import {
    Image
} from "vant";
import {
    getProjectTeam
} from "@/js/designer/index.js";


import share from "../components/share.vue"


export default {
    name: "project-team",
    components: {
        VantImage: Image,
        qrcodePopup,
        share
    },
    data() {
        return {
            isShowShare: false,
            // 标签渲染数组
            arrServiceTags: [
                {
                    name: "上门设计",
                },
                {
                    name: "专属定制",
                },

                {
                    name: "一站式售后",
                },
                {
                    name: "三维实景方案",
                },
                {
                    name: "施工全流程在线交付",
                },
                {
                    name: "实时在线监管",
                },
            ],
            dataList: [], // 负责人列表
            imgUrl: {},
            isPopup: false,
            counName: '',
            counEwm: '',
            arrMent: {},
            project: '',
        };
    },
    created() {
        this.$store.commit("loadSkeleton", {bool: true}); // 页面loading开启
        $init(() => {
            this.$oInitData.designerInfo({
                h5_user_id: this.$storage.getStorage("user_id"),
            }).then((res) => {
                let objData = this.$route.query;
                if (objData.sampleroom == 2) {
                    this.isShowShare = true;
                }
                this.getTeamData()
            }).catch((error) => {
                this.$store.commit("loadSkeleton", {bool: false}); // 页面loading关闭
            });
        });
    },
    computed: {
        setTile() {
            return function (value) {
                if (value == "project_manager") return "项目经理";
                if (value == "project_supervisor") return "监理";
                if (value == "project_salesperson") return "签单手";
                if (value == "project_designer") return "设计者";
                if (value == "project_responsible_person") return "施工人员";
            };
        },
    },
    methods: {
        addCount(params) {
            this.isPopup = false
        },
        getTeamData() {
            let objPrject = this.$storage.getStorage('designer_prject')
            this.$store.commit("loadSkeleton", {
                bool: true,
                type: "team"
            }); // 页面loading开启
            getProjectTeam({
                projectmgnid: objPrject.new_srv_projectmgnid,
                sampleroom:   this.$route.query.sampleroom || '',
            }).then(res => {
                this.$store.commit("loadSkeleton", {bool: false}); // 页面loading关闭
                let objData = res.data.result.team
                for (let i in objData) {
                    if (objData[i].length != 0) {
                        this.dataList.push({
                            i,
                            ...objData[i]
                        })
                    }
                }
                console.log(this.dataList, 'this.dataList');
            })
        },
        getHome() {
            // let Object =  this.$route.query;;
            this.$router.go(-2)
        },
        changeIsPopup(item) {
            this.arrMent = item
            this.isPopup = true
        }
    }
};
</script>

<style lang="scss" scoped>
@import "./index";
</style>
